// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedPreparationStatus_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="13" cy="13" r="3" fill="#FDCA40"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.37578 10.0932L0 12.4689L1.41421 13.8831L3.42098 11.8764C3.63673 12.131 3.87334 12.3673 4.12816 12.5828L2.12131 14.5897L3.53552 15.99L5.91304 13.6264C6.56311 13.8676 7.26634 13.9994 8.00035 13.9994C8.37643 13.9994 8.74444 13.9648 9.10135 13.8986C9.03504 13.6098 9 13.309 9 13C9 12.5907 9.06147 12.1958 9.17568 11.824C8.80405 11.938 8.40937 11.9994 8.00035 11.9994C7.85276 11.9994 7.70703 11.9914 7.56358 11.9758L11.9768 7.56265C11.9924 7.7061 12.0004 7.85183 12.0004 7.99942C12.0004 8.4087 11.9389 8.80363 11.8247 9.17546C12.1963 9.06139 12.591 9 13 9C13.3092 9 13.6103 9.0351 13.8994 9.10151C13.9657 8.74426 14.0004 8.37589 14.0004 7.99942C14.0004 7.26541 13.8685 6.56218 13.6273 5.91211L15.99 3.53627L14.5889 2.12206L12.5838 4.12723C12.3683 3.87241 12.1319 3.6358 11.8773 3.42005L13.8831 1.41421L12.4689 0L10.0941 2.37485C9.44223 2.1321 8.73678 1.99942 8.00035 1.99942C4.68664 1.99942 2.00035 4.68571 2.00035 7.99942C2.00035 8.73585 2.13303 9.4413 2.37578 10.0932ZM5.54985 11.1612L11.1621 5.54892C10.957 5.28476 10.7196 5.04699 10.4558 4.84155L4.84248 10.4549C5.04791 10.7187 5.28569 10.9561 5.54985 11.1612ZM8.44507 4.02386L4.02479 8.44414C4.00864 8.29813 4.00035 8.14974 4.00035 7.99942C4.00035 5.79028 5.79121 3.99942 8.00035 3.99942C8.15067 3.99942 8.29905 4.00771 8.44507 4.02386Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedPreparationStatus is a generated icon component.
 */
let IconMedPreparationStatus = IconMedPreparationStatus_1 = class IconMedPreparationStatus extends IconBaseElement {
    render() {
        return html `${IconMedPreparationStatus_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedPreparationStatus.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedPreparationStatus = IconMedPreparationStatus_1 = __decorate([
    customElement('zui-icon-med-preparation-status')
], IconMedPreparationStatus);
export { IconMedPreparationStatus };
